import { RestaurantHours } from "../restaurant/RestaurantHours";
import { Status } from "../restaurant/RestaurantStatus";
import { PaymentOptions } from "../restaurant/RestaurantPaymentOptions";
import { RestaurantReceiptRules } from "../restaurant/RestaurantReceiptRules";
import { AboutRestaurant } from "../restaurant/AboutRestaurant";

export class RestaurantInformation {
    restaurantId: string;
    title: string;
    zip: string;
    address: string;
    phone: string;
    sendToSMS: string[];
    sendToEmails: string[];
    hasPickup: boolean;
    hasDelivery: boolean;
    hasRewardPointsProgram:boolean;
    paymentOptions: PaymentOptions;
    status:Status;
    pickupHours:RestaurantHours;
    deliveryHours:RestaurantHours;
    restaurantModule:string | null;
    minimumOrderTotalPickup:number;
    minimumOrderTotalDelivery:number;
    minTimeForPickup:number | null;
    minTimeForDelivery:number | null;
    restaurantSquareLocationId:string|null;
    receiptRules:RestaurantReceiptRules|null;
    googleReviewLink:string|null;
    aboutRestaurant:AboutRestaurant|null;



    constructor(restaurantId: string, title: string, zip: string, address: string, phone: string, sendToSMS: string[], sendToEmails: string[], 
        hasPickup: boolean, hasDelivery: boolean, hasRewardPointsProgram:boolean, paymentOptions: PaymentOptions, status:Status, pickupHours:RestaurantHours, 
        deliveryHours:RestaurantHours, restaurantModule:string | null,minimumOrderTotalPickup:number, minimumOrderTotalDelivery:number, minTimeForPickup:number | null,
        minTimeForDelivery:number | null, restaurantSquareLocationId:string|null, receiptRules:RestaurantReceiptRules|null,googleReviewLink:string|null,
        aboutRestaurant:AboutRestaurant|null) {
        this.restaurantId = restaurantId;
        this.title = title;
        this.zip = zip;
        this.address = address
        this.phone = phone;
        this.sendToSMS = sendToSMS;
        this.sendToEmails = sendToEmails;
        this.hasPickup = hasPickup;
        this.hasDelivery = hasDelivery;
        this.hasRewardPointsProgram = hasRewardPointsProgram;
        this.paymentOptions = paymentOptions;
        this.status = status;
        this.pickupHours = pickupHours;
        this.deliveryHours = deliveryHours;
        this.restaurantModule = restaurantModule;
        this.minimumOrderTotalPickup   = (minimumOrderTotalPickup==null)?0:minimumOrderTotalPickup;
		this.minimumOrderTotalDelivery = (minimumOrderTotalDelivery==null)?0:minimumOrderTotalDelivery;
		this.minTimeForPickup 	 = minTimeForPickup;
        this.minTimeForDelivery  = minTimeForDelivery;
        this.restaurantSquareLocationId = restaurantSquareLocationId;
        this.receiptRules = receiptRules;
        this.googleReviewLink = googleReviewLink;
        this.aboutRestaurant = aboutRestaurant;
    }

    toAwsObject() {
        let restaurantInfo: any = {
            "restaurantId": this.restaurantId,
            "title": this.title,
            "zip": this.zip,
            "address": this.address,
            "phone": this.phone,
            "sendToSMS": this.sendToSMS,
            "sendToEmails": this.sendToEmails,
            "hasPickup": this.hasPickup,
            "hasDelivery": this.hasDelivery,
            "hasRewardPointsProgram": this.hasRewardPointsProgram,
            "paymentOptions": this.paymentOptions.toAWSObject(),
            "status":this.status.toAWSObject(),
            "pickupHours":this.pickupHours,
            "deliveryHours":this.deliveryHours,
            "restaurantModule":this.restaurantModule,
            "minimumOrderTotalPickup":this.minimumOrderTotalPickup,
            "minimumOrderTotalDelivery":this.minimumOrderTotalDelivery,
            "minTimeForPickup":this.minTimeForPickup,
            "minTimeForDelivery":this.minTimeForDelivery,
            "restaurantSquareLocationId":this.restaurantSquareLocationId,
            "googleReviewLink":this.googleReviewLink
        };
        if(this.receiptRules!=null){
            restaurantInfo["receiptRules"] = this.receiptRules.toAwsObj();
        }
        if(this.aboutRestaurant!=null){
            restaurantInfo["aboutRestaurant"] = this.aboutRestaurant.toAWSObject();
        }
        return restaurantInfo;
    }

    static newfromAwsData(awsRestaurantInfoData: any) {
        if (awsRestaurantInfoData != null) {
            return new RestaurantInformation(
                awsRestaurantInfoData.restaurantId,
                awsRestaurantInfoData.title,
                awsRestaurantInfoData.zip,
                awsRestaurantInfoData.address,
                awsRestaurantInfoData.phone,
                awsRestaurantInfoData.sendToSMS,
                awsRestaurantInfoData.sendToEmails,
                awsRestaurantInfoData.hasPickup,
                awsRestaurantInfoData.hasDelivery,
                awsRestaurantInfoData.hasRewardPointsProgram,
                PaymentOptions.newFromAws(awsRestaurantInfoData.paymentOptions),
                Status.newFromAws(awsRestaurantInfoData.status),
                RestaurantHours.newFromAws(awsRestaurantInfoData.pickupHours),
                RestaurantHours.newFromAws(awsRestaurantInfoData.deliveryHours),
                awsRestaurantInfoData.restaurantModule,
                awsRestaurantInfoData.minimumOrderTotalPickup,
                awsRestaurantInfoData.minimumOrderTotalDelivery,
                awsRestaurantInfoData.minTimeForPickup,
                awsRestaurantInfoData.minTimeForDelivery,
                awsRestaurantInfoData.restaurantSquareLocationId,
                RestaurantReceiptRules.newFromAws(awsRestaurantInfoData.receiptRules),
                awsRestaurantInfoData.googleReviewLink,
                AboutRestaurant.newFromAws(awsRestaurantInfoData.aboutRestaurant),
            );
        } else {
            return undefined;
        }
    }

}